import { useTranslation } from "react-i18next";
import textos from "./textos/Oferta2Noches.jsx";

// Pàgina "oferta-2-noches" de l'Hotel Camprodon. Els textos propis de cada idioma
// són a textos/Oferta2Noches.jsx; els genèrics, amb t() (Traducciones/lang).
// El comportament (sliders, galeria, formularis...) és a ContenidoHtml.
const Oferta2Noches = ({ lang }) => {

    const { t } = useTranslation();
    const tx = textos[lang] ?? textos.es;

    return (
        <>
            <section className="c-hero c-hero--large">
                <div className="c-hero--container" style={{maxHeight: "100vh"}}>
                    <div>
                        <div className="position-relative">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/offers__hotel-camprodon__1920x1036__pareja-montana-ofertas-hotel-camprodon-1678198851.jpeg" alt={tx.heroImageAlt} className="image-cover image-full c-hero__image" width="100%" height="100%" />
                            </picture>
                            <div className="c-hero__content position-relative">
                                <span className="c-hero__small-title text-uppercase">{tx.heroSmallTitle}</span>
                                <h1 className="c-hero__title">{tx.heroTitle}</h1>
                                <span className="line max-line-height">
                                    <svg aria-hidden="true" focusable="false" className="c-icon ico-mouse">
                                        <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-mouse-scrolldown"></use>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="c-sticky-widget-notifier"></div>
            <section className="c-sticky-widgets d-inline-flex position-relative">
                <div className="c-sticky-widgets--button c-sticky-widgets--booking d-flex-center"><a href={tx.stickyWidgetsButtonHref} className="text-uppercase text-center d-flex-center">{t("Reserva hotel")}</a></div>
                <div className="c-sticky-widgets--button c-sticky-widgets--restaurant d-flex-center"><a href={tx.stickyWidgetsButtonHref2} target="_blank" className="text-uppercase text-center d-flex-center" rel="noopener noreferrer">{t("Reserva restaurante")}</a></div>
            </section>
            <section className="position-relative bg-gray ">
                <div className="c-benefits-slider d-flex-center o-container">
                    <span className="c-benefits-slider__small-title text-uppercase">{t("Ventajas de reservar en el web oficial")}</span>
                    <ul id="draggable-slider" className="c-slider list-style-none m-0 p-0">
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__millor-preu-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Mejor precio garantizado")} />
                            </picture>
                            <div>
                                <span>{t("Mejor precio garantizado")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__reserva-segura-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Reserva segura")} />
                            </picture>
                            <div>
                                <span>{t("Reserva segura")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__confirmacio-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Confirmación inmediata")} />
                            </picture>
                            <div>
                                <span>{t("Confirmación inmediata")}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
            <section className="c-presentation o-container text-center ">
                <div className="c-presentation__small-title text-uppercase">{tx.presentationSmallTitle}</div>
                <h2 className="c-presentation__title">{tx.presentationTitle}</h2>
                <div className="c-presentation__content">
                    <p>{tx.presentationContent}</p>
                </div>
            </section>
            <section className="o-container">
                <div className="c-cards-list">
                    <article className="c-card c-card--with-price">
                        <div className="c-card__header">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/offers__hotel-camprodon__549x333__oferta-2-noches-hotel-camprodon-1678199750.jpeg" className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" alt={t("Oferta 2 noches")} />
                            </picture>
                        </div>
                        <div className="c-card__body">
                            <div className="c-card__content">
                                <h2 className="c-card__title">{t("Oferta 2 noches")}</h2>
                                <p>{tx.cardContent}</p>
                            </div>
                            <div className="c-card__footer"><a href={tx.linkHref} className="c-link">{tx.link}</a>{" "}<a href={tx.buttonHref} className="c-button c-button--primary c-button--large">{tx.button}</a></div>
                        </div>
                    </article>
                </div>
            </section>
            <section id="contact-form-section" className="c-form bg-very-light-gray">
                <div className="o-container">
                    <div className="c-form--title">{tx.formTitle}</div>
                    <div className="c-form--content">{tx.formContent}</div>
                    <form id="contact-form" data-hc-form="1" action="#" method="post" className="c-form__form">
                        <input type="hidden" name="language" id="language" value={tx.languageValue} />
                        <div className="c-form__inputs">
                            <div className="c-form--element c-form--input"><input className="c-input" type="text" id="name" name="name" defaultValue="" placeholder=" " />{" "}<label className="c-label" htmlFor="name">{t("Nombre")}</label></div>
                            <div className="c-form--element c-form--input"><input className="c-input" type="email" id="email" name="email" defaultValue="" placeholder=" " />{" "}<label className="c-label" htmlFor="email">{t("Correo electrónico")}</label></div>
                        </div>
                        <div className="c-form--element"><label className="c-label" htmlFor="comments">{t("Comentarios_formulario")}</label>{" "}<textarea className="c-input" name="comments" id="comments" cols="30" rows="9" placeholder={t("Comentarios...")}></textarea></div>
                        <div className="c-form--element"></div>
                        <div className="c-form__footer d-inline-flex-md">
                            <div>
                                <div className="c-checkbox"><input type="checkbox" name="legal_checkbox" tabIndex="-1" id="legal_checkbox" />{" "}<label htmlFor="legal_checkbox">
                                        <div className="c-checkbox__square"></div>
                                        <span><span>{t("He leído y acepto las")}</span>{" "}<a href={tx.checkboxHref}>{t("Condiciones Generales y la Política de Privacidad")}</a></span>
                                    </label></div>
                            </div>
                            <input type="submit" className="c-button c-button--outline c-button--full c-form--submit c-form--submit-btn c-form--element" value={t("Enviar")} />
                        </div>
                    </form>
                </div>
            </section>
            <section className="bg-very-light-gray text-center-lg ">
                <div className="c-contact-methods d-inline-flex-md o-container">
                    <div className="c-contact-methods__item"><svg aria-hidden="true" focusable="false" className="c-icon ico-email">
                            <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-email-form"></use>
                        </svg>{" "}<div className="d-inline-block">
                            <div className="title text-uppercase">{t("Por correo")}</div>
                            <span>
                                <a style={{all: "unset", cursor: "pointer"}} href="mailto:info@hotelcamprodon.com">{" info@hotelcamprodon.com "}</a>
                            </span>
                        </div></div>
                    <div className="c-contact-methods__item d-flex-center-md"><svg aria-hidden="true" focusable="false" className="c-icon ico-phone">
                            <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-phone-form"></use>
                        </svg>{" "}<div className="d-inline-block">
                            <div className="title text-uppercase">{t("Por teléfono")}</div>
                            <span>
                                <a style={{all: "unset", cursor: "pointer"}} href="tel:972740013">{" 972 74 00 13 "}</a>
                            </span>
                        </div></div>
                </div>
            </section>
        </>
    );
};

export default Oferta2Noches;
